/*
 * @Author: zhouwei
 * @Date: 2020-05-15 15:10:04
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 14:51:41
 * @Desc: 搜索名称下拉选择组件
*/
<template>
  <div class="select-member">
    <i class="el-icon-search"></i>
    <mk-select
      v-model="name"
      class="select-member-select"
      clearable
      filterable
      remote
      :remote-method="querySearchAsync"
      :placeholder="placeholder"
      :loading="isFetchData"
      @change="change"
    >
      <mk-option
        v-for="(item, index) in nameOptions"
        :key="index"
        :label="item[config.name]"
        :value="item[config.id]"
      >
        <span
          style="float: left; margin-right: 8px;"
        >{{ item[config.name] }}</span>
        <span
          style="float: right; color: #8492a6; font-size: 13px;"
        >{{ item.deptName }}</span>
      </mk-option>
    </mk-select>
  </div>
</template>
<script>
import { CLUEAPIS } from '@api'
export default {
  name: 'SearchSelectMember',
  model: {
    prop: 'member',
    event: 'change'
  },
  props: {
    deptApi: {
      type: Object,
      default () {
        return {
          name: ACCOUNTAPIS.OrganisationApi.v1OrganisationFindDepListGet,
          params: {}
        }
      }
    },
    memberApi: {
      type: Object,
      default () {
        return {
          name: ACCOUNTAPIS.OrganisationApi.v1OrganisationAllGet,
          params: {}
        }
      }
    },
    placeholder: {
      type: String,
      default: '输入员工名搜索'
    },
    member: {
      type: [Number, String],
      default: ''
    },
    config: {
      type: Object,
      default () {
        return {
          id: 'userId',
          name: 'name'
        }
      }
    },
    type: {
      type: String,
      default: 'sale'
    }
  },
  data () {
    return {
      nameOptions: [],
      isFetchData: false,
      deptList: [], // 部门列表
      memberList: [], // 成员列表
      name: ''
    }
  },
  created () {
    if (this.type === 'sale') {
      this.getDeptList()
    }
  },
  methods: {
    async getDeptList () {
      const { success, data } = await this.deptApi.name({
        ...this.deptApi.params
      })
      if (success) {
        this.deptList = data
        this.getMemberList()
      }
    },
    async getMemberList () {
      const { success, data } = await this.memberApi.name({
        ...this.memberApi.params
      })
      if (success) {
        this.memberList = data
        this.memberList.forEach(item => {
          let i = 0
          let len = this.deptList.length
          for (i; i < len; i++) {
            if (item.departmentId === this.deptList[i].id) {
              item.deptName = this.deptList[i].name
              break
            } else {
              if (item.departmentId === 'NA') {
                item.deptName = JSON.parse(window.localStorage.getItem('user')).accountName
                break
              }
            }
          }
        })
      }
    },
    async querySearchAsync (str) {
      if (this.type === 'sale') {
        if (str !== '') {
          this.isFetchData = true
          this.nameOptions = this.memberList.filter(item => {
            return item.name.match(str)
          })
          this.isFetchData = false
        } else {
          this.isFetchData = false
          this.nameOptions = []
        }
      } else {
        this.isFetchData = true
        const res = await CLUEAPIS.ClueApi.clueMkListAllPost({
          name: str
        })
        if (res.success) {
          this.isFetchData = false
          this.nameOptions = res.data.data
        }
      }
    },
    change () {
      this.$emit('change', this.name)
    }
  }
}
</script>
<style lang="scss" scoped>
  .select-member {
    position: relative;
    display: inline-block;
    width: 100%;

    .el-icon-search {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      font-size: 14px;
      color: #bfbfbf;
      z-index: 2;
    }

    /deep/ .el-select {
      width: 100% !important;

      .el-input__inner {
        padding: 0 30px;
      }
    }
  }
</style>
